<template lang="pug">
    .container.content(v-if="image" ref="container")
        component(:is="tag" v-bind="props")
            .image
                figure(:style="{ width: `${width}px`, height: `${height}px` }")
                    img(
                        v-lazy="image"
                        :title="title || subTitle"
                        :style="{ width: `${width}px`, height: `${height}px` }"
                        rel="noopener"
                    )
                p(v-if="title") {{ title }}
                small(v-if="subTitle") {{ subTitle }}
</template>

<script>

import _ from 'lodash'

export default {
    name: 'ImageSection',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            maxW: undefined,
            // aspectRatio: undefined,
            // w: undefined,
            // h: undefined,
        }
    },
    computed: {
        content() {
            return _.get(this.section, 'contents.0')
        },
        title() {
            return _.get(this.content, 'title')
        },
        subTitle() {
            return _.get(this.content, 'sub_title')
        },
        Hyperlink() {
            return _.get(this.content, 'sub_title')
        },
        width() {
            if (this.image.width && this.maxW) return _.min([this.image.width, this.maxW])
            else return undefined
        },
        height() {
            if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio
            else return undefined
        },
        image() {
            const image = _.get(this.content, 'images.0')
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h, fx, fy, fz } = parameters

            let width, height, aspectRatio

            width = image.width / fz
            height = image.height / fz
            aspectRatio = width / height

            height = Math.min(window.innerWidth >= 1088 ? 780 : 400, height)
            width = height * aspectRatio

            if (w && h) {
                aspectRatio = w / h

                height = Math.min(window.innerWidth >= 1088 ? 780 : 400, image.height / fz)
                width = height * aspectRatio

                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
                width,
                height,
                aspectRatio,
            }
        },
        tag() {
            let tag = 'div';
            if (this.path) tag = 'router-link';
            else if (this.href) tag = 'a';
            return tag;
        },
        props() {
            let props = {};
            switch (this.tag) {
                case 'router-link':
                    props.to = this.path;
                    break;
            }
            return props;
        },
        href() {
            let href = false;
            if (this.content.hyperlink.type !== 'internal' && _.get(this.content.hyperlink, 'href')) {
                const link = this.content.hyperlink;
                switch (link.type) {
                    case 'external':
                        if (!startsWith(link.href, 'https://') && !startsWith(link.href, 'https://'))
                            href = `https://${link.href}`;
                        else href = link.href;
                        break;
                    case 'mailto':
                        href = `mailto:${link.href}`;
                        break;
                    case 'tel':
                        href = `tel:${link.href}`;
                        break;
                }
            }
            return href;
        },
        target() {
            return _.get(this.content.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.content.hyperlink.type === 'internal' && _.get(this.content.hyperlink, 'menuItem.path'))
                return this.content.hyperlink.menuItem.path;
            else return false;
        }

    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxW = this.$refs.container.clientWidth
                this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    .content
        display: flex
        flex-direction: column
        align-items: center
        .image
            figure
                display: block
                margin-bottom: 2px
                img
                    width: auto
                    height: initial
                    border-radius: 4px
                    display: inline-block
                    &[lazy=loading]
                        box-shadow: none
                    &[lazy=loaded]
                        // max-height: 500px
                        // height: initial !important
                        // width: initial !important
                        box-shadow: $box-shadow-3
            p
                margin-bottom: 0
                font-size: .8rem
            small
                font-size: .65rem
                display: block
</style>
